import { mutationTypes } from './types';

const mutations = {
  [mutationTypes.SET_CATEGORY](state, payload) {
    state.catalog = {
      ...state.catalog,
      category: payload,
    };
  },
  [mutationTypes.SET_ROL](state, payload) {
    state.catalog = {
      ...state.catalog,
      rol: payload,
    };
  },
  [mutationTypes.SET_CURRENT_FILTER](state, payload) {
    state.currentFilter = payload;
  },
  [mutationTypes.SET_FILTER](state, payload) {
    state.filter = payload;
  },
  [mutationTypes.SET_EVENTS](state, payload) {
    state.events = payload;
  },
  [mutationTypes.SET_DELETE_EVENT](state, payload) {
    state.events = state.events.filter((s) => {
      return s.id !== payload;
    });
  },
};

export default mutations;
